import { MinLengthFieldError } from "../../errors";
import { FieldValidation } from "../../protocols";

export class MinLengthValidation implements FieldValidation {
  constructor(readonly field: string, private readonly minLength: number) {}

  validate(input: any): Error | null {
    return input[this.field]?.length < this.minLength
      ? new MinLengthFieldError()
      : null;
  }
}
